import { useCallback } from 'react';
import useNavigationContext, { NavItems } from '@hooks/use-navigation-context';
import { useRouter } from 'next/router';

// Returns an isActive function that checks navigationContext against a NavItem (Legacy)
// TODO: Scope removal of navigation context in favour of smarter route checking.
// Functionality has been isolated here to make it easier to remove in future
type LegacyIsActive = {
  legacyIsActive: (navItem: NavItems) => boolean;
  handleSelectItem: () => void;
};

const useLegacyIsActive = (): LegacyIsActive => {
  const navigationContext = useNavigationContext();

  const handleSelectItem = () => {
    navigationContext.makeInactive(navigationContext.activeId);
  };

  const legacyIsActive = useCallback(
    (navItem: NavItems) => {
      return navigationContext.activeId === navItem;
    },
    [navigationContext.activeId]
  );
  return { legacyIsActive, handleSelectItem };
};

// Returns an isActive function that checks router context against a NavItem
const useIsActive = (): ((navItem: NavItems) => boolean) => {
  const router = useRouter();
  const isActive = useCallback(
    (navItem: NavItems) => {
      // Returns path after workspace ID
      if (router.isReady) {
        const normalisedPath = router.asPath.split('/').slice(2).join('/');
        return normalisedPath.startsWith(navItem);
      }
      return false;
    },
    [router.asPath, router.isReady]
  );
  return isActive;
};

export { useIsActive, useLegacyIsActive };
